// src/pages/TaleplerimPage.js
import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';

const fmt = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '-';
const fmtPara = (t, pb) => t ? Number(t).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' ' + (pb || 'TRY') : '-';

const DURUM_MAP = {
  bekliyor:              { label: 'Bekliyor',          renk: '#D97706', bg: '#FEF3C7' },
  onay_sureci:           { label: 'Onay Sürecinde',    renk: '#D97706', bg: '#FEF3C7' },
  hr_onay_bekliyor:      { label: 'HR Onay Bekliyor',  renk: '#D97706', bg: '#FEF3C7' },
  muhasebeci_bekleniyor: { label: 'Muhasebede',        renk: '#2563EB', bg: '#DBEAFE' },
  tamamlandi:            { label: 'Tamamlandı',         renk: '#059669', bg: '#D1FAE5' },
  onaylandi:             { label: 'Onaylandı',          renk: '#059669', bg: '#D1FAE5' },
  reddedildi:            { label: 'Reddedildi',         renk: '#DC2626', bg: '#FEE2E2' },
  iptal:                 { label: 'İptal',              renk: '#6B7280', bg: '#F3F4F6' },
  taslak:                { label: 'Taslak',             renk: '#6B7280', bg: '#F3F4F6' },
  revize:                { label: '↩ Revize İstendi',  renk: '#7C3AED', bg: '#EDE9FE' },
};

const MASRAF_KATEGORILER = ['Ulaşım', 'Konaklama', 'Yemek', 'Temsil', 'Ofis Malzemesi', 'Eğitim', 'Diğer'];
const KATEGORI_ICON = { 'Ulaşım': '✈️', 'Konaklama': '🏨', 'Yemek': '🍽️', 'Temsil': '🤝', 'Ofis Malzemesi': '📦', 'Eğitim': '📚', 'Diğer': '📋' };

const DurumBadge = ({ durum }) => {
  const d = DURUM_MAP[durum] || { label: durum, renk: '#6B7280', bg: '#F3F4F6' };
  return (
    <span style={{ background: d.bg, color: d.renk, fontSize: '11px', fontWeight: 700, padding: '3px 10px', borderRadius: '99px', whiteSpace: 'nowrap' }}>
      {d.label}
    </span>
  );
};

export default function TaleplerimPage() {
  const [sekme, setSekme] = useState(() => {
    const path = window.location.pathname;
    const alt = path.split('/')[2];
    return ['izin','vize','masraf'].includes(alt) ? alt : 'izin';
  });

  React.useEffect(() => {
    window.history.replaceState({}, '', '/taleplerim/' + sekme);
    document.title = {izin:'İzin Talepleri', vize:'Vize Evrak', masraf:'Masraf'}[sekme] + ' - Valure HR';
  }, [sekme]);

  React.useEffect(() => {
    const handlePop = () => {
      const alt = window.location.pathname.split('/')[2];
      if (alt && ['izin','vize','masraf'].includes(alt)) setSekme(alt);
    };
    window.addEventListener('popstate', handlePop);
    return () => window.removeEventListener('popstate', handlePop);
  }, []);
  const [vizeTalepleri, setVizeTalepleri] = useState([]);
  const [izinTalepleri, setIzinTalepleri] = useState([]);
  const [masrafTalepleri, setMasrafTalepleri] = useState([]);
  const [izinTurleri, setIzinTurleri] = useState([]);
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);

  const [izinPanel, setIzinPanel] = useState(false);
  const [izinForm, setIzinForm] = useState({ izin_turu: '', baslangic_tarihi: '', bitis_tarihi: '', aciklama: '' });
  const [duzenlePanel, setDuzenlePanel] = useState(null);
  const [duzenleForm, setDuzenleForm] = useState({ izin_turu: '', baslangic_tarihi: '', bitis_tarihi: '', aciklama: '' });

  const [vizePanel, setVizePanel] = useState(false);
  const [vizeForm, setVizeForm] = useState({ ad: '', soyad: '', pozisyon: '', ise_giris_tarihi: '', maas: '', izin_baslangic: '', izin_bitis: '', gidilecek_ulke: '', sponsor: false });

  const [seciliMasraf, setSeciliMasraf] = useState(null);
  const [masrafDetay, setMasrafDetay] = useState(null);
  const [yeniMasrafPanel, setYeniMasrafPanel] = useState(false);
  const [masrafForm, setMasrafForm] = useState({ baslik: '', aciklama: '', para_birimi: 'TRY' });
  const [kalemPanel, setKalemPanel] = useState(false);
  const [kalemForm, setKalemForm] = useState({ kategori: '', aciklama: '', tutar: '', tarih: new Date().toISOString().slice(0,10), fis: null });
  const [dragOver, setDragOver] = useState(false);
  const [kalemDuzenle, setKalemDuzenle] = useState(null); // düzenlenen kalem id
  const [kalemDuzenleForm, setKalemDuzenleForm] = useState({ kategori: '', aciklama: '', tutar: '', tarih: '', fis: null });
  const [masrafDuzenleModal, setMasrafDuzenleModal] = useState(false);
  const [masrafDuzenleForm, setMasrafDuzenleForm] = useState({ baslik: '', aciklama: '', para_birimi: 'TRY' });
  const fisRef = useRef(null);

  const yukle = useCallback(async () => {
    try {
      const [vize, izin, masraf, izinTur] = await Promise.all([
        axios.get('/api/talepler/benim'),
        axios.get('/api/personel/izinler'),
        axios.get('/api/masraf/benim'),
        axios.get('/api/admin/dinamik-listeler/izin_turleri').catch(() => ({ data: [] })),
      ]);
      setVizeTalepleri(vize.data);
      setIzinTalepleri(izin.data);
      setMasrafTalepleri(masraf.data);
      setIzinTurleri(izinTur.data);
    } catch (err) { console.error(err); }
  }, []);

  useEffect(() => { yukle(); }, [yukle]);

  const flash = (tip, mesaj) => { setSonuc({ tip, mesaj }); setTimeout(() => setSonuc(null), 4000); };

  const masrafDetayGetir = async (id) => {
    const r = await axios.get('/api/masraf/' + id);
    setMasrafDetay(r.data);
    setSeciliMasraf(id);
  };

  const izinGonder = async (e) => {
    e.preventDefault(); setYukleniyor(true);
    try {
      await axios.post('/api/personel/izinler', izinForm);
      flash('basari', 'İzin talebi oluşturuldu ve onay sürecine gönderildi.');
      setIzinPanel(false);
      setIzinForm({ izin_turu: '', baslangic_tarihi: '', bitis_tarihi: '', aciklama: '' });
      yukle();
    } catch(err) { flash('hata', err.response?.data?.hata || 'Hata oluştu.'); }
    finally { setYukleniyor(false); }
  };

  const izinIptal = async (id) => {
    if (!window.confirm('Bu izin talebini iptal etmek istiyor musunuz?')) return;
    try {
      await axios.delete('/api/personel/izinler/' + id);
      flash('basari', 'İzin talebi iptal edildi.');
      yukle();
    } catch(err) { flash('hata', err.response?.data?.hata || 'İptal edilemedi.'); }
  };

  const izinDuzenleAc = (izin) => {
    setDuzenleForm({ izin_turu: izin.izin_turu, baslangic_tarihi: izin.baslangic_tarihi, bitis_tarihi: izin.bitis_tarihi, aciklama: izin.aciklama || '' });
    setDuzenlePanel(izin.id);
    setIzinPanel(false);
  };

  const izinGuncelleVeGonder = async (id) => {
    try {
      await axios.put('/api/personel/izinler/' + id, duzenleForm);
      await axios.post('/api/personel/izinler/' + id + '/yeniden-gonder');
      flash('basari', 'Talep güncellendi ve yeniden onaya gönderildi.');
      setDuzenlePanel(null);
      yukle();
    } catch(err) { flash('hata', err.response?.data?.hata || 'Hata oluştu.'); }
  };

  const gunHesapla = (form) => {
    if (!form.baslangic_tarihi || !form.bitis_tarihi) return 0;
    return Math.max(0, Math.ceil((new Date(form.bitis_tarihi) - new Date(form.baslangic_tarihi)) / (1000*60*60*24)) + 1);
  };

  const vizeGonder = async (e) => {
    e.preventDefault(); setYukleniyor(true);
    try {
      await axios.post('/api/talepler', vizeForm);
      flash('basari', 'Vize evrak talebi oluşturuldu.');
      setVizePanel(false);
      setVizeForm({ ad: '', soyad: '', pozisyon: '', ise_giris_tarihi: '', maas: '', izin_baslangic: '', izin_bitis: '', gidilecek_ulke: '', sponsor: false });
      yukle();
    } catch(err) { flash('hata', err.response?.data?.hata || 'Hata oluştu.'); }
    finally { setYukleniyor(false); }
  };

  const masrafOlustur = async () => {
    if (!masrafForm.baslik) { flash('hata', 'Başlık zorunludur'); return; }
    try {
      const r = await axios.post('/api/masraf', masrafForm);
      setYeniMasrafPanel(false);
      setMasrafForm({ baslik: '', aciklama: '', para_birimi: 'TRY' });
      await yukle();
      await masrafDetayGetir(r.data.id);
      flash('basari', 'Masraf talebi oluşturuldu.');
    } catch(err) { flash('hata', err.response?.data?.hata || 'Hata'); }
  };

  const kalemEkle = async () => {
    if (!kalemForm.kategori || !kalemForm.aciklama || !kalemForm.tutar || !kalemForm.tarih) {
      flash('hata', 'Tüm alanları doldurun'); return;
    }
    try {
      const fd = new FormData();
      fd.append('kategori', kalemForm.kategori);
      fd.append('aciklama', kalemForm.aciklama);
      fd.append('tutar', kalemForm.tutar);
      fd.append('tarih', kalemForm.tarih);
      if (kalemForm.fis) fd.append('fis', kalemForm.fis);
      await axios.post(`/api/masraf/${seciliMasraf}/kalem`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setKalemPanel(false);
      setKalemForm({ kategori: '', aciklama: '', tutar: '', tarih: new Date().toISOString().slice(0,10), fis: null });
      await masrafDetayGetir(seciliMasraf);
      await yukle();
      flash('basari', 'Kalem eklendi.');
    } catch(err) { flash('hata', err.response?.data?.hata || 'Hata'); }
  };

  const kalemSil = async (kalemId) => {
    if (!window.confirm('Bu kalemi silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`/api/masraf/${seciliMasraf}/kalem/${kalemId}`);
      masrafDetayGetir(seciliMasraf);
      yukle();
    } catch(err) { flash('hata', err.response?.data?.hata || 'Hata'); }
  };

  const kalemGuncelle = async () => {
    if (!kalemDuzenleForm.kategori || !kalemDuzenleForm.aciklama || !kalemDuzenleForm.tutar || !kalemDuzenleForm.tarih) {
      flash('hata', 'Tüm alanları doldurun'); return;
    }
    try {
      const fd = new FormData();
      fd.append('kategori', kalemDuzenleForm.kategori);
      fd.append('aciklama', kalemDuzenleForm.aciklama);
      fd.append('tutar', kalemDuzenleForm.tutar);
      fd.append('tarih', kalemDuzenleForm.tarih);
      if (kalemDuzenleForm.fis) fd.append('fis', kalemDuzenleForm.fis);
      await axios.put(`/api/masraf/${seciliMasraf}/kalem/${kalemDuzenle}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setKalemDuzenle(null);
      await masrafDetayGetir(seciliMasraf);
      await yukle();
      flash('basari', 'Kalem güncellendi.');
    } catch(err) { flash('hata', err.response?.data?.hata || 'Hata'); }
  };

  const masrafOnayaGonder = async () => {
    if (!window.confirm('Talebi onaya göndermek istediğinize emin misiniz?')) return;
    try {
      await axios.post(`/api/masraf/${seciliMasraf}/gonder`);
      flash('basari', 'Talep onaya gönderildi.');
      await yukle();
      masrafDetayGetir(seciliMasraf);
    } catch(err) { flash('hata', err.response?.data?.hata || 'Hata'); }
  };

  const masrafSil = async (id) => {
    if (!window.confirm('Bu talebi silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`/api/masraf/${id}`);
      setSeciliMasraf(null); setMasrafDetay(null);
      yukle();
    } catch(err) { flash('hata', err.response?.data?.hata || 'Hata'); }
  };

  const handleFileDrop = (e) => {
    e.preventDefault(); setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file && (file.type === 'application/pdf' || file.type.startsWith('image/'))) {
      setKalemForm(f => ({ ...f, fis: file }));
    } else {
      flash('hata', 'Sadece PDF, JPG veya PNG yükleyebilirsiniz.');
    }
  };

  const bekleyen = (arr) => arr.filter(t => ['bekliyor','onay_sureci','hr_onay_bekliyor','muhasebeci_bekleniyor'].includes(t.durum)).length;

  const inputStyle = { width: '100%', padding: '9px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };
  const labelStyle = { fontSize: '12px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '5px' };
  const btnPrimary = (bg = '#4F46E5') => ({ background: bg, color: '#fff', border: 'none', padding: '9px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' });
  const btnSecondary = { background: '#F3F4F6', color: '#374151', border: 'none', padding: '9px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' };

  return (
    <div style={{ padding: '0', maxWidth: '1200px' }}>

      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', fontWeight: 700, marginBottom: '4px' }}>📋 Taleplerim</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Tüm taleplerinizi buradan yönetin.</p>
      </div>

      {sonuc && (
        <div style={{
          background: sonuc.tip === 'basari' ? '#F0FDF4' : '#FEF2F2',
          color: sonuc.tip === 'basari' ? '#16A34A' : '#DC2626',
          padding: '12px 16px', borderRadius: '10px', marginBottom: '1rem', fontSize: '14px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          borderLeft: `4px solid ${sonuc.tip === 'basari' ? '#16A34A' : '#DC2626'}`
        }}>
          <span>{sonuc.tip === 'basari' ? '✅' : '⚠️'} {sonuc.mesaj}</span>
          <button onClick={() => setSonuc(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', color: 'inherit' }}>✕</button>
        </div>
      )}

      {/* Özet kartlar */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '1.5rem' }}>
        {[
          { label: 'İzin', sayi: izinTalepleri.length, icon: '🏖️', renk: '#2563EB', key: 'izin' },
          { label: 'Vize Evrak', sayi: vizeTalepleri.length, icon: '✈️', renk: '#7C3AED', key: 'vize' },
          { label: 'Masraf', sayi: masrafTalepleri.length, icon: '💸', renk: '#059669', key: 'masraf' },
          { label: 'Bekleyen', sayi: bekleyen(izinTalepleri) + bekleyen(vizeTalepleri) + bekleyen(masrafTalepleri), icon: '⏳', renk: '#D97706' },
        ].map(k => (
          <div key={k.label} onClick={() => k.key && setSekme(k.key)} style={{
            background: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB',
            padding: '16px 20px', cursor: k.key ? 'pointer' : 'default',
            borderTop: `3px solid ${k.renk}`,
            boxShadow: sekme === k.key ? `0 0 0 2px ${k.renk}30` : '0 1px 3px rgba(0,0,0,0.05)',
            transition: 'all 0.15s'
          }}>
            <div style={{ fontSize: '22px', marginBottom: '6px' }}>{k.icon}</div>
            <div style={{ fontSize: '26px', fontWeight: 700, color: k.renk }}>{k.sayi}</div>
            <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '2px' }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Sekmeler */}
      <div style={{ display: 'flex', borderBottom: '1px solid #E5E7EB', marginBottom: '1.5rem' }}>
        {[
          { key: 'izin', icon: '🏖️', label: 'İzin Talepleri', sayi: izinTalepleri.length },
          { key: 'vize', icon: '✈️', label: 'Vize Evrak', sayi: vizeTalepleri.length },
          { key: 'masraf', icon: '💸', label: 'Masraf', sayi: masrafTalepleri.length },
        ].map(s => (
          <button key={s.key} onClick={() => { setSekme(s.key); setSeciliMasraf(null); setMasrafDetay(null); }}
            style={{
              padding: '10px 20px', border: 'none', background: 'none', cursor: 'pointer',
              fontSize: '14px', fontWeight: sekme === s.key ? 700 : 400,
              color: sekme === s.key ? '#4F46E5' : '#6B7280',
              borderBottom: sekme === s.key ? '2px solid #4F46E5' : '2px solid transparent',
              whiteSpace: 'nowrap'
            }}>
            {s.icon} {s.label}
            <span style={{ marginLeft: '6px', background: '#F3F4F6', color: '#6B7280', fontSize: '11px', padding: '1px 7px', borderRadius: '99px' }}>{s.sayi}</span>
          </button>
        ))}
      </div>

      {/* ── İZİN ── */}
      {sekme === 'izin' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
            <button onClick={() => { setIzinPanel(!izinPanel); setDuzenlePanel(null); }} style={btnPrimary()}>+ Yeni İzin Talebi</button>
          </div>

          {izinPanel && (
            <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', borderLeft: '4px solid #4F46E5', padding: '20px', marginBottom: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
              <h3 style={{ fontSize: '15px', fontWeight: 700, marginBottom: '1rem' }}>🏖️ Yeni İzin Talebi</h3>
              <form onSubmit={izinGonder}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div style={{ gridColumn: '1/-1' }}>
                    <label style={labelStyle}>İzin Türü *</label>
                    <select value={izinForm.izin_turu} onChange={e => setIzinForm({ ...izinForm, izin_turu: e.target.value })} required style={inputStyle}>
                      <option value="">-- Seçin --</option>
                      {izinTurleri.map(t => <option key={t.deger} value={t.deger}>{t.etiket}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Başlangıç *</label>
                    <input type="date" value={izinForm.baslangic_tarihi} onChange={e => setIzinForm({ ...izinForm, baslangic_tarihi: e.target.value })} required style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Bitiş *</label>
                    <input type="date" value={izinForm.bitis_tarihi} min={izinForm.baslangic_tarihi} onChange={e => setIzinForm({ ...izinForm, bitis_tarihi: e.target.value })} required style={inputStyle} />
                  </div>
                  {gunHesapla(izinForm) > 0 && (
                    <div style={{ gridColumn: '1/-1' }}>
                      <div style={{ background: '#EEF2FF', borderRadius: '8px', padding: '10px 14px', fontSize: '14px', color: '#4F46E5', fontWeight: 600 }}>
                        📅 Toplam: {gunHesapla(izinForm)} gün
                      </div>
                    </div>
                  )}
                  <div style={{ gridColumn: '1/-1' }}>
                    <label style={labelStyle}>Açıklama</label>
                    <textarea value={izinForm.aciklama} onChange={e => setIzinForm({ ...izinForm, aciklama: e.target.value })} rows={2} style={{ ...inputStyle, resize: 'vertical' }} />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '14px' }}>
                  <button type="submit" disabled={yukleniyor} style={btnPrimary()}>{yukleniyor ? 'Gönderiliyor...' : 'Gönder'}</button>
                  <button type="button" onClick={() => setIzinPanel(false)} style={btnSecondary}>İptal</button>
                </div>
              </form>
            </div>
          )}

          {duzenlePanel && (
            <div style={{ background: '#FFFBEB', borderRadius: '12px', border: '1px solid #FCD34D', borderLeft: '4px solid #F59E0B', padding: '20px', marginBottom: '1.5rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <h3 style={{ fontSize: '15px', fontWeight: 700, margin: 0, color: '#92400E' }}>↩ Revize — Talebi Düzenle ve Gönder</h3>
                <button onClick={() => setDuzenlePanel(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px' }}>✕</button>
              </div>
              <div style={{ background: '#FEF3C7', borderRadius: '8px', padding: '10px 14px', marginBottom: '14px', fontSize: '13px', color: '#92400E' }}>
                ⚠️ Revize istendi. Gerekli düzeltmeleri yapıp yeniden gönderin.
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div style={{ gridColumn: '1/-1' }}>
                  <label style={labelStyle}>İzin Türü *</label>
                  <select value={duzenleForm.izin_turu} onChange={e => setDuzenleForm(f => ({ ...f, izin_turu: e.target.value }))} style={inputStyle}>
                    <option value="">-- Seçin --</option>
                    {izinTurleri.map(t => <option key={t.deger} value={t.deger}>{t.etiket}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Başlangıç *</label>
                  <input type="date" value={duzenleForm.baslangic_tarihi} onChange={e => setDuzenleForm(f => ({ ...f, baslangic_tarihi: e.target.value }))} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Bitiş *</label>
                  <input type="date" value={duzenleForm.bitis_tarihi} min={duzenleForm.baslangic_tarihi} onChange={e => setDuzenleForm(f => ({ ...f, bitis_tarihi: e.target.value }))} style={inputStyle} />
                </div>
                {gunHesapla(duzenleForm) > 0 && (
                  <div style={{ gridColumn: '1/-1' }}>
                    <div style={{ background: '#EEF2FF', borderRadius: '8px', padding: '10px 14px', fontSize: '14px', color: '#4F46E5', fontWeight: 600 }}>📅 Toplam: {gunHesapla(duzenleForm)} gün</div>
                  </div>
                )}
                <div style={{ gridColumn: '1/-1' }}>
                  <label style={labelStyle}>Açıklama</label>
                  <textarea value={duzenleForm.aciklama} onChange={e => setDuzenleForm(f => ({ ...f, aciklama: e.target.value }))} rows={2} style={{ ...inputStyle, resize: 'vertical' }} />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', marginTop: '14px' }}>
                <button onClick={() => izinGuncelleVeGonder(duzenlePanel)} style={btnPrimary('#F59E0B')}>↩ Güncelle ve Yeniden Gönder</button>
                <button onClick={() => setDuzenlePanel(null)} style={btnSecondary}>İptal</button>
              </div>
            </div>
          )}

          <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', overflow: 'hidden' }}>
            {izinTalepleri.length === 0 ? (
              <div style={{ padding: '4rem', textAlign: 'center', color: '#9CA3AF' }}>
                <div style={{ fontSize: '48px', marginBottom: '12px' }}>🏖️</div>
                <p style={{ fontWeight: 600, marginBottom: '8px' }}>Henüz izin talebiniz yok</p>
                <button onClick={() => setIzinPanel(true)} style={btnPrimary()}>İlk talebi oluştur</button>
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#F9FAFB', borderBottom: '1px solid #E5E7EB' }}>
                    {['İzin Türü', 'Başlangıç', 'Bitiş', 'Gün', 'Durum', 'Not', ''].map(h => (
                      <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontSize: '11px', fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {izinTalepleri.map((i, idx) => (
                    <tr key={i.id} style={{ borderBottom: idx < izinTalepleri.length - 1 ? '1px solid #F3F4F6' : 'none' }}>
                      <td style={{ padding: '12px 14px', fontWeight: 600, fontSize: '13px' }}>{i.izin_turu}</td>
                      <td style={{ padding: '12px 14px', fontSize: '13px', color: '#6B7280' }}>{fmt(i.baslangic_tarihi)}</td>
                      <td style={{ padding: '12px 14px', fontSize: '13px', color: '#6B7280' }}>{fmt(i.bitis_tarihi)}</td>
                      <td style={{ padding: '12px 14px', fontSize: '13px', fontWeight: 600 }}>{i.gun_sayisi}</td>
                      <td style={{ padding: '12px 14px' }}><DurumBadge durum={i.durum} /></td>
                      <td style={{ padding: '12px 14px', fontSize: '12px', color: '#9CA3AF', maxWidth: '160px' }}>
                        {i.onay_notu ? <span title={i.onay_notu} style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{i.onay_notu}</span> : '—'}
                      </td>
                      <td style={{ padding: '12px 14px' }}>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          {['bekliyor','onay_sureci'].includes(i.durum) && (
                            <button onClick={() => izinIptal(i.id)} style={{ background: '#FEE2E2', color: '#DC2626', border: 'none', padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>İptal</button>
                          )}
                          {i.durum === 'revize' && (
                            <>
                              <button onClick={() => izinDuzenleAc(i)} style={{ background: '#FEF3C7', color: '#92400E', border: 'none', padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>✏️ Düzenle</button>
                              <button onClick={() => izinIptal(i.id)} style={{ background: '#FEE2E2', color: '#DC2626', border: 'none', padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>İptal</button>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      {/* ── VİZE ── */}
      {sekme === 'vize' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
            <button onClick={() => setVizePanel(!vizePanel)} style={btnPrimary('#7C3AED')}>+ Yeni Vize Evrak Talebi</button>
          </div>
          {vizePanel && (
            <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', borderLeft: '4px solid #7C3AED', padding: '20px', marginBottom: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
              <h3 style={{ fontSize: '15px', fontWeight: 700, marginBottom: '1rem' }}>✈️ Yeni Vize Evrak Talebi</h3>
              <form onSubmit={vizeGonder}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  {[
                    { label: 'Ad *', key: 'ad' }, { label: 'Soyad *', key: 'soyad' },
                    { label: 'Pozisyon *', key: 'pozisyon' }, { label: 'İşe Giriş Tarihi *', key: 'ise_giris_tarihi', type: 'date' },
                    { label: 'Maaş *', key: 'maas' }, { label: 'Gidilecek Ülke *', key: 'gidilecek_ulke' },
                    { label: 'İzin Başlangıç *', key: 'izin_baslangic', type: 'date' }, { label: 'İzin Bitiş *', key: 'izin_bitis', type: 'date' },
                  ].map(f => (
                    <div key={f.key}>
                      <label style={labelStyle}>{f.label}</label>
                      <input type={f.type || 'text'} value={vizeForm[f.key]} onChange={e => setVizeForm({ ...vizeForm, [f.key]: e.target.value })} required={f.label.includes('*')} style={inputStyle} />
                    </div>
                  ))}
                  <div style={{ gridColumn: '1/-1' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: 500 }}>
                      <input type="checkbox" checked={vizeForm.sponsor} onChange={e => setVizeForm({ ...vizeForm, sponsor: e.target.checked })} />
                      Sponsor mektubu gerekiyor
                    </label>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '14px' }}>
                  <button type="submit" disabled={yukleniyor} style={btnPrimary('#7C3AED')}>{yukleniyor ? 'Gönderiliyor...' : 'Gönder'}</button>
                  <button type="button" onClick={() => setVizePanel(false)} style={btnSecondary}>İptal</button>
                </div>
              </form>
            </div>
          )}
          <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', overflow: 'hidden' }}>
            {vizeTalepleri.length === 0 ? (
              <div style={{ padding: '4rem', textAlign: 'center', color: '#9CA3AF' }}>
                <div style={{ fontSize: '48px', marginBottom: '12px' }}>✈️</div>
                <p style={{ fontWeight: 600 }}>Henüz vize evrak talebiniz yok</p>
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#F9FAFB', borderBottom: '1px solid #E5E7EB' }}>
                    {['Ülke', 'İzin Başlangıç', 'İzin Bitiş', 'Durum', 'Tarih'].map(h => (
                      <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontSize: '11px', fontWeight: 700, color: '#6B7280', textTransform: 'uppercase' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {vizeTalepleri.map((v, idx) => (
                    <tr key={v.id} style={{ borderBottom: idx < vizeTalepleri.length - 1 ? '1px solid #F3F4F6' : 'none' }}>
                      <td style={{ padding: '12px 14px', fontWeight: 600, fontSize: '13px' }}>{v.gidilecek_ulke}</td>
                      <td style={{ padding: '12px 14px', fontSize: '13px', color: '#6B7280' }}>{fmt(v.izin_baslangic)}</td>
                      <td style={{ padding: '12px 14px', fontSize: '13px', color: '#6B7280' }}>{fmt(v.izin_bitis)}</td>
                      <td style={{ padding: '12px 14px' }}><DurumBadge durum={v.durum} /></td>
                      <td style={{ padding: '12px 14px', fontSize: '13px', color: '#6B7280' }}>{fmt(v.olusturma_tarihi)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      {/* ── MASRAF ── */}
      {sekme === 'masraf' && (
        <div style={{ display: 'grid', gridTemplateColumns: seciliMasraf ? '360px 1fr' : '1fr', gap: '20px', alignItems: 'start' }}>

          {/* Sol: Liste */}
          <div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
              <button onClick={async () => {
                try {
                  const r = await axios.post('/api/masraf', { baslik: 'Yeni Masraf - ' + new Date().toLocaleDateString('tr-TR'), aciklama: '', para_birimi: 'TRY' });
                  await yukle();
                  await masrafDetayGetir(r.data.id);
                  setKalemPanel(true);
                  setKalemForm({ kategori: '', aciklama: '', tutar: '', tarih: new Date().toISOString().slice(0,10), fis: null });
                } catch(err) { flash('hata', err.response?.data?.hata || 'Hata'); }
              }} style={btnPrimary('#059669')}>+ Yeni Masraf Talebi</button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {masrafTalepleri.length === 0 ? (
                <div style={{ padding: '4rem', textAlign: 'center', color: '#9CA3AF', background: '#F9FAFB', borderRadius: '12px', border: '2px dashed #E5E7EB' }}>
                  <div style={{ fontSize: '48px', marginBottom: '12px' }}>💸</div>
                  <p style={{ fontWeight: 600 }}>Henüz masraf talebiniz yok</p>
                </div>
              ) : masrafTalepleri.map(m => {
                const d = DURUM_MAP[m.durum] || DURUM_MAP.taslak;
                return (
                  <div key={m.id} onClick={() => masrafDetayGetir(m.id)} style={{
                    background: '#fff', borderRadius: '10px',
                    border: `1.5px solid ${seciliMasraf === m.id ? '#059669' : '#E5E7EB'}`,
                    borderLeft: `4px solid ${d.renk}`,
                    padding: '12px 16px', cursor: 'pointer',
                    boxShadow: seciliMasraf === m.id ? `0 0 0 3px ${d.renk}20` : '0 1px 3px rgba(0,0,0,0.05)',
                    transition: 'all 0.15s'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontWeight: 700, fontSize: '14px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.baslik}</div>
                        <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '3px', display: 'flex', gap: '8px' }}>
                          <span>📋 {m.kalem_sayisi || 0} kalem</span>
                          <span>📅 {fmt(m.olusturma_tarihi)}</span>
                        </div>
                      </div>
                      <div style={{ textAlign: 'right', flexShrink: 0 }}>
                        <div style={{ fontWeight: 700, fontSize: '14px' }}>{m.toplam_tutar ? fmtPara(m.toplam_tutar, m.para_birimi) : '—'}</div>
                        <DurumBadge durum={m.durum} />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Sağ: Detay */}
          {seciliMasraf && masrafDetay && (
            <div style={{ background: '#fff', borderRadius: '14px', border: '1px solid #E5E7EB', overflow: 'hidden', boxShadow: '0 4px 16px rgba(0,0,0,0.06)' }}>
              <div style={{ padding: '16px 20px', borderBottom: '1px solid #F3F4F6', background: '#F9FAFB', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  {masrafDetay.durum === 'taslak' ? (
                    <input
                      defaultValue={masrafDetay.baslik}
                      onBlur={async (e) => {
                        if (e.target.value && e.target.value !== masrafDetay.baslik) {
                          await axios.put(`/api/masraf/${masrafDetay.id}`, { ...masrafDetay, baslik: e.target.value });
                          await masrafDetayGetir(masrafDetay.id);
                          await yukle();
                        }
                      }}
                      style={{ fontWeight: 700, fontSize: '15px', border: '1.5px solid #E5E7EB', borderRadius: '6px', padding: '4px 8px', width: '100%', outline: 'none' }}
                    />
                  ) : (
                    <div style={{ fontWeight: 700, fontSize: '16px' }}>{masrafDetay.baslik}</div>
                  )}
                  <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '2px' }}>{fmt(masrafDetay.olusturma_tarihi)} · {masrafDetay.para_birimi}</div>
                </div>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <DurumBadge durum={masrafDetay.durum} />
                  <button onClick={() => { setSeciliMasraf(null); setMasrafDetay(null); setKalemPanel(false); }}
                    style={{ background: '#F3F4F6', border: 'none', borderRadius: '6px', width: '28px', height: '28px', cursor: 'pointer', fontSize: '16px' }}>✕</button>
                </div>
              </div>

              {masrafDetay.onaylar?.length > 0 && (
                <div style={{ padding: '12px 20px', borderBottom: '1px solid #F3F4F6', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center', background: '#FAFAFA' }}>
                  {masrafDetay.onaylar.map((o, idx) => (
                    <React.Fragment key={o.id}>
                      <div style={{ background: o.durum === 'onaylandi' ? '#F0FDF4' : o.durum === 'reddedildi' ? '#FEF2F2' : '#F9FAFB', border: `1px solid ${o.durum === 'onaylandi' ? '#86EFAC' : o.durum === 'reddedildi' ? '#FCA5A5' : '#E5E7EB'}`, borderRadius: '8px', padding: '8px 12px', minWidth: '110px' }}>
                        <div style={{ fontSize: '10px', fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase' }}>Adım {o.sira}</div>
                        <div style={{ fontSize: '12px', fontWeight: 600 }}>{o.adim_baslik}</div>
                        <div style={{ fontSize: '11px', color: o.durum === 'onaylandi' ? '#059669' : o.durum === 'reddedildi' ? '#DC2626' : '#9CA3AF', marginTop: '2px' }}>
                          {o.durum === 'onaylandi' ? `✓ ${o.onaylayan_ad}` : o.durum === 'reddedildi' ? `✗ ${o.onaylayan_ad}` : '⏳ Bekliyor'}
                        </div>
                      </div>
                      {idx < masrafDetay.onaylar.length - 1 && <span style={{ color: '#D1D5DB', fontSize: '18px' }}>→</span>}
                    </React.Fragment>
                  ))}
                </div>
              )}

              <div style={{ padding: '16px 20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                  <span style={{ fontWeight: 700, fontSize: '14px' }}>Masraf Kalemleri</span>
                  {masrafDetay.durum === 'taslak' && (
                    <button onClick={() => { setKalemPanel(!kalemPanel); setKalemForm({ kategori: '', aciklama: '', tutar: '', tarih: new Date().toISOString().slice(0,10), fis: null }); }}
                      style={{ background: '#EEF2FF', color: '#4F46E5', border: 'none', padding: '6px 14px', borderRadius: '7px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>
                      + Kalem Ekle
                    </button>
                  )}
                </div>

                {kalemPanel && masrafDetay.durum === 'taslak' && (
                  <div style={{ background: '#F8FAFF', borderRadius: '10px', border: '1px solid #E0E7FF', padding: '16px', marginBottom: '14px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
                      <div>
                        <label style={{ ...labelStyle, fontSize: '11px' }}>Kategori *</label>
                        <select value={kalemForm.kategori} onChange={e => setKalemForm(f => ({ ...f, kategori: e.target.value }))}
                          style={{ width: '100%', padding: '8px 10px', border: '1.5px solid #E5E7EB', borderRadius: '7px', fontSize: '13px', boxSizing: 'border-box' }}>
                          <option value="">Seçin</option>
                          {MASRAF_KATEGORILER.map(k => <option key={k} value={k}>{KATEGORI_ICON[k]} {k}</option>)}
                        </select>
                      </div>
                      <div>
                        <label style={{ ...labelStyle, fontSize: '11px' }}>Tarih *</label>
                        <input type="date" value={kalemForm.tarih} onChange={e => setKalemForm(f => ({ ...f, tarih: e.target.value }))}
                          style={{ width: '100%', padding: '8px 10px', border: '1.5px solid #E5E7EB', borderRadius: '7px', fontSize: '13px', boxSizing: 'border-box' }} />
                      </div>
                      <div style={{ gridColumn: '1/-1' }}>
                        <label style={{ ...labelStyle, fontSize: '11px' }}>Açıklama *</label>
                        <input value={kalemForm.aciklama} onChange={e => setKalemForm(f => ({ ...f, aciklama: e.target.value }))} placeholder="örn: İstanbul-Ankara uçak bileti"
                          style={{ width: '100%', padding: '8px 10px', border: '1.5px solid #E5E7EB', borderRadius: '7px', fontSize: '13px', boxSizing: 'border-box' }} />
                      </div>
                      <div>
                        <label style={{ ...labelStyle, fontSize: '11px' }}>Tutar *</label>
                        <input type="number" value={kalemForm.tutar} onChange={e => setKalemForm(f => ({ ...f, tutar: e.target.value }))} placeholder="0.00"
                          style={{ width: '100%', padding: '8px 10px', border: '1.5px solid #E5E7EB', borderRadius: '7px', fontSize: '13px', boxSizing: 'border-box' }} />
                      </div>
                      <div>
                        <label style={{ ...labelStyle, fontSize: '11px' }}>Fiş / Fatura (PDF, JPG, PNG)</label>
                        <div
                          onDragOver={e => { e.preventDefault(); setDragOver(true); }}
                          onDragLeave={() => setDragOver(false)}
                          onDrop={handleFileDrop}
                          onClick={() => fisRef.current?.click()}
                          style={{
                            border: `2px dashed ${dragOver ? '#4F46E5' : '#D1D5DB'}`,
                            borderRadius: '7px', padding: '8px', cursor: 'pointer',
                            background: dragOver ? '#EEF2FF' : '#fff',
                            textAlign: 'center', fontSize: '12px', color: '#9CA3AF',
                            minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            transition: 'all 0.15s'
                          }}>
                          {kalemForm.fis
                            ? <span style={{ color: '#059669', fontWeight: 600 }}>📎 {kalemForm.fis.name.length > 18 ? kalemForm.fis.name.slice(0,18) + '...' : kalemForm.fis.name}</span>
                            : <span>📎 Sürükle veya tıkla</span>
                          }
                        </div>
                        <input ref={fisRef} type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display: 'none' }}
                          onChange={e => { if (e.target.files[0]) setKalemForm(f => ({ ...f, fis: e.target.files[0] })); }} />
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button onClick={kalemEkle} style={{ background: '#4F46E5', color: '#fff', border: 'none', padding: '8px 18px', borderRadius: '7px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' }}>Ekle</button>
                      <button onClick={() => setKalemPanel(false)} style={{ background: '#F3F4F6', color: '#374151', border: 'none', padding: '8px 18px', borderRadius: '7px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' }}>İptal</button>
                    </div>
                  </div>
                )}

                {(!masrafDetay.kalemler || masrafDetay.kalemler.length === 0) ? (
                  <div style={{ textAlign: 'center', padding: '24px', background: '#F9FAFB', borderRadius: '8px', color: '#9CA3AF', fontSize: '13px' }}>Henüz kalem eklenmemiş</div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '14px' }}>
                    {masrafDetay.kalemler.map(k => (
                      <div key={k.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', background: '#F9FAFB', borderRadius: '8px', padding: '10px 14px', border: '1px solid #F3F4F6' }}>
                        <span style={{ fontSize: '20px', flexShrink: 0 }}>{KATEGORI_ICON[k.kategori] || '📋'}</span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: '13px', fontWeight: 600 }}>{k.aciklama}</div>
                          <div style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '1px' }}>{k.kategori} · {fmt(k.tarih)}</div>
                        </div>
                        <div style={{ fontWeight: 700, fontSize: '13px', flexShrink: 0 }}>{fmtPara(k.tutar, masrafDetay.para_birimi)}</div>
                        {k.fis_adi && (
                          <button onClick={async (e) => {
                            e.preventDefault(); e.stopPropagation();
                            try {
                              const token = localStorage.getItem('token');
                              const r = await fetch(`/api/masraf/kalem/${k.id}/fis`, { headers: { Authorization: `Bearer ${token}` } });
                              if (!r.ok) { flash('hata', 'Dosya açılamadı'); return; }
                              const blob = await r.blob();
                              const url = URL.createObjectURL(blob);
                              window.open(url, '_blank');
                            } catch { flash('hata', 'Dosya açılamadı'); }
                          }} style={{ fontSize: '11px', color: '#059669', background: '#D1FAE5', border: 'none', padding: '4px 10px', borderRadius: '5px', fontWeight: 600, flexShrink: 0, cursor: 'pointer' }}
                            title={k.fis_adi}>📎 Fatura</button>
                        )}
                        {masrafDetay.durum === 'taslak' && (
                          <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
                            <button onClick={() => {
                              setKalemDuzenle(k.id);
                              setKalemDuzenleForm({ kategori: k.kategori, aciklama: k.aciklama, tutar: k.tutar, tarih: k.tarih ? k.tarih.slice(0,10) : '', fis: null });
                            }} style={{ background: '#EEF2FF', color: '#4F46E5', border: 'none', padding: '4px 10px', borderRadius: '5px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>Düzenle</button>
                            <button onClick={() => kalemSil(k.id)} style={{ background: '#FEE2E2', color: '#DC2626', border: 'none', padding: '4px 10px', borderRadius: '5px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>Sil</button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                <div style={{ borderTop: '2px solid #E5E7EB', paddingTop: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
                  <span style={{ fontWeight: 700, fontSize: '15px' }}>Toplam</span>
                  <span style={{ fontWeight: 700, fontSize: '20px', color: '#4F46E5' }}>{fmtPara(masrafDetay.toplam_tutar, masrafDetay.para_birimi)}</span>
                </div>

                {masrafDetay.durum === 'taslak' && (
                  <>
                    {kalemDuzenle && (
                      <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                        <div style={{ background: '#fff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '500px', boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                            <h2 style={{ fontSize: '20px', fontWeight: 700, margin: 0 }}>✏️ Kalemi Düzenle</h2>
                            <button onClick={() => setKalemDuzenle(null)} style={{ background: '#F3F4F6', border: 'none', borderRadius: '8px', width: '32px', height: '32px', cursor: 'pointer', fontSize: '18px' }}>✕</button>
                          </div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
                            <div>
                              <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Kategori *</label>
                              <select value={kalemDuzenleForm.kategori} onChange={e => setKalemDuzenleForm(f => ({...f, kategori: e.target.value}))}
                                style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                                <option value="">Seçin</option>
                                {MASRAF_KATEGORILER.map(k => <option key={k} value={k}>{KATEGORI_ICON[k]} {k}</option>)}
                              </select>
                            </div>
                            <div>
                              <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Tarih *</label>
                              <input type="date" value={kalemDuzenleForm.tarih} onChange={e => setKalemDuzenleForm(f => ({...f, tarih: e.target.value}))}
                                style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                            </div>
                            <div style={{ gridColumn: '1/-1' }}>
                              <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Açıklama *</label>
                              <input value={kalemDuzenleForm.aciklama} onChange={e => setKalemDuzenleForm(f => ({...f, aciklama: e.target.value}))}
                                style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                            </div>
                            <div>
                              <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Tutar *</label>
                              <input type="number" value={kalemDuzenleForm.tutar} onChange={e => setKalemDuzenleForm(f => ({...f, tutar: e.target.value}))}
                                style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                            </div>
                            <div>
                              <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Fiş / Fatura (PDF, JPG, PNG)</label>
                              <div onClick={() => fisRef.current?.click()}
                                style={{ border: '2px dashed #D1D5DB', borderRadius: '8px', padding: '10px', cursor: 'pointer', background: '#fff', textAlign: 'center', fontSize: '12px', color: '#9CA3AF' }}>
                                {kalemDuzenleForm.fis ? <span style={{ color: '#059669', fontWeight: 600 }}>📎 {kalemDuzenleForm.fis.name}</span> : <span>📎 Yeni fiş yükle (isteğe bağlı)</span>}
                              </div>
                              <input ref={fisRef} type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display: 'none' }}
                                onChange={e => { if (e.target.files[0]) setKalemDuzenleForm(f => ({...f, fis: e.target.files[0]})); }} />
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
                            <button onClick={() => setKalemDuzenle(null)}
                              style={{ flex: 1, padding: '11px', borderRadius: '8px', border: '1.5px solid #E5E7EB', background: '#fff', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
                            <button onClick={kalemGuncelle}
                              style={{ flex: 2, padding: '11px', borderRadius: '8px', border: 'none', background: '#4F46E5', color: '#fff', cursor: 'pointer', fontWeight: 700, fontSize: '14px' }}>Kaydet</button>
                          </div>
                        </div>
                      </div>
                    )}

                    {masrafDuzenleModal && (
                      <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                        <div style={{ background: '#fff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '480px', boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                            <h2 style={{ fontSize: '20px', fontWeight: 700, margin: 0 }}>✏️ Masraf Talebini Düzenle</h2>
                            <button onClick={() => setMasrafDuzenleModal(false)} style={{ background: '#F3F4F6', border: 'none', borderRadius: '8px', width: '32px', height: '32px', cursor: 'pointer', fontSize: '18px' }}>✕</button>
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <div>
                              <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Başlık *</label>
                              <input value={masrafDuzenleForm.baslik} onChange={e => setMasrafDuzenleForm(f => ({...f, baslik: e.target.value}))}
                                style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                            </div>
                            <div>
                              <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Açıklama</label>
                              <textarea value={masrafDuzenleForm.aciklama} onChange={e => setMasrafDuzenleForm(f => ({...f, aciklama: e.target.value}))} rows={4}
                                style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', resize: 'vertical', boxSizing: 'border-box' }} />
                            </div>
                            <div>
                              <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Para Birimi</label>
                              <select value={masrafDuzenleForm.para_birimi} onChange={e => setMasrafDuzenleForm(f => ({...f, para_birimi: e.target.value}))}
                                style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                                <option value="TRY">TRY — Türk Lirası</option>
                                <option value="USD">USD — Amerikan Doları</option>
                                <option value="EUR">EUR — Euro</option>
                                <option value="GBP">GBP — İngiliz Sterlini</option>
                              </select>
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
                            <button onClick={() => setMasrafDuzenleModal(false)}
                              style={{ flex: 1, padding: '11px', borderRadius: '8px', border: '1.5px solid #E5E7EB', background: '#fff', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
                            <button onClick={async () => {
                              try {
                                await axios.put(`/api/masraf/${masrafDetay.id}`, masrafDuzenleForm);
                                await masrafDetayGetir(masrafDetay.id);
                                await yukle();
                                setMasrafDuzenleModal(false);
                                flash('basari', 'Masraf güncellendi.');
                              } catch(err) { flash('hata', err.response?.data?.hata || 'Hata'); }
                            }} style={{ flex: 2, padding: '11px', borderRadius: '8px', border: 'none', background: '#4F46E5', color: '#fff', cursor: 'pointer', fontWeight: 700, fontSize: '14px' }}>Kaydet</button>
                          </div>
                        </div>
                      </div>
                    )}
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button onClick={masrafOnayaGonder} disabled={!masrafDetay.kalemler?.length}
                        style={{ flex: 2, padding: '11px', background: masrafDetay.kalemler?.length ? '#059669' : '#9CA3AF', color: '#fff', border: 'none', borderRadius: '8px', cursor: masrafDetay.kalemler?.length ? 'pointer' : 'not-allowed', fontWeight: 700, fontSize: '14px' }}>
                        ✅ Onaya Gönder
                      </button>

                      <button onClick={() => masrafSil(masrafDetay.id)}
                        style={{ flex: 1, padding: '11px', background: '#FEE2E2', color: '#DC2626', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' }}>
                        Sil
                      </button>
                    </div>
                  </>
                )}
                {masrafDetay.durum === 'reddedildi' && (
                  <button onClick={() => masrafSil(masrafDetay.id)}
                    style={{ width: '100%', padding: '11px', background: '#FEE2E2', color: '#DC2626', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}>
                    Talebi Sil
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
